import { useMutation } from '@apollo/client';
import React, { useCallback, useContext } from 'react';
import Mutation from './MessageListUpdateMutation.gql';
import {
  MessageListUpdate as IData,
  MessageListUpdateVariables as IVariables,
} from './_QueryTypes/MessageListUpdate';
import messageListQuery from '../Querys/MessageListQuery.gql';
import {
  MessageListQuery,
  MessageListQueryVariables,
} from '../Querys/_QueryTypes/MessageListQuery';
import { LoginStateContext } from '../../../Features/Login/Contexts/LoginStateContext/LoginStateContext';
import { ActiveDatabaseContext } from '../../ActiveDatabaseContext/ActiveDatabaseContext';
import { getMessageListSelection } from '../Querys/MessageListQuery';
import { assocPath } from 'ramda';

interface IProps {
  children: (updateMessages: MessageUpdateType) => React.ReactNode;
}
export type MessageUpdateType = (variables: IVariables) => void;

const MessageListUpdateMutation: React.FC<IProps> = props => {
  const { sign } = useContext(LoginStateContext);
  const activeDatabase = useContext(ActiveDatabaseContext).activeDatabase;
  const [updateFunction] = useMutation<IData, IVariables>(Mutation);
  const updateMessages: MessageUpdateType = useCallback(
    variables => {
      updateFunction({
        variables: variables,
        optimisticResponse: {
          rtn: {
            SYSMessageSetStatus: {
              id: variables.id,
              _version: variables._version + 1,
              LAST: Boolean(variables.newReadStatus),
              __typename: 'TEDSYSMessageInfo',
            },
            __typename: 'TEDAvenyRoutineMutation',
          },
        },
        update: (store, result) => {
          const selection = getMessageListSelection(sign);
          const data = store.readQuery<
            MessageListQuery,
            MessageListQueryVariables
          >({
            query: messageListQuery,
            variables: {
              databaseName: activeDatabase || '',
              selection,
            },
          });

          const newMessage = result.data?.rtn?.SYSMessageSetStatus;
          if (data && data.db && data.db.SYSMeddelandeTill_All && newMessage) {
            const meddelandeIndex = data.db.SYSMeddelandeTill_All.findIndex(
              message => newMessage.id === message.id
            );

            if (meddelandeIndex !== -1) {
              const oldMessage = data.db.SYSMeddelandeTill_All[meddelandeIndex];
              const newData = assocPath(
                ['db', 'SYSMeddelandeTill_All', meddelandeIndex],
                {
                  ...oldMessage,
                  LAST: newMessage.LAST,
                  _version: newMessage._version,
                },
                data
              );

              store.writeQuery({
                query: messageListQuery,
                variables: {
                  databaseName: activeDatabase || '',
                  selection,
                },
                data: newData,
              });
            }
          }
        },
      });
    },
    [activeDatabase, sign, updateFunction]
  );
  return <>{props.children(updateMessages)}</>;
};

export default MessageListUpdateMutation;
